import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import Loader from './Loader';

class DoceboEnrollment extends Component {

	handleChange = (event) => {
		event.preventDefault();		
        const { docebo } = this.props.shopStore;   
		docebo.set(event.target.name, event.target.value);
    }

	handleSubmit = (event) => {
		event.preventDefault();    		         
        if (this.isFormValid()) {			
			this.props.shopStore.enrollInDocebo();   
        }        
	}  
	
	handleBlur = (event) => {
		event.preventDefault();
		this.validateForm();		
	}

	validateForm() {
		const { docebo } = this.props.shopStore;  
		const password = docebo.get('password');
		const threeConsecutiveDigitsRegex = /[0-9]{3}/;		
		if (password.length < 6) {
			docebo.set('formError', 'Password must be at least six characters.');
		} else if (threeConsecutiveDigitsRegex.test(password)) {
			docebo.set('formError', 'Password cannot contain more than two consecutive digits.');
		} else if (password !== docebo.get('confirmPassword')) {
			docebo.set('formError', 'Passwords must match.');			
		} else {
			docebo.set('formError', '');
		}
	}

	isFormValid() {
		this.validateForm();
		const { docebo } = this.props.shopStore;   
		if (docebo.get('formError')) {
			return false;
		}
		return true;
	}

	componentDidMount() {
		this.props.shopStore.searchDoceboUser();
	}
	
	renderForm() {
		const { docebo } = this.props.shopStore; 
		return (
			<span>
				<p>
					To complete your order, you must set up your KabbalahOne user account. Please
					choose a password for your account.
				</p>				
				<form className="needs-validation text-left" noValidate onSubmit={this.handleSubmit}>
					<div className="col-sm-12">
		
					</div>
					<div className="form-group">
						<label>
							Username/Email
						</label>
						<input 				
							type="text" 
							className="form-control"
							name="username" 
							placeholder="" 
							value={this.props.shopStore.billingInfo.get('email')} 														
							disabled
						/>						
					</div>	
					<div className="form-group">
						<label>
							Select a Password
						</label>
						<input 				
							type="password" 
							className="form-control"
							name="password" 
							placeholder="" 
							value={docebo.get('password')} 
							onChange={this.handleChange}
							onBlur={this.handleBlur}							
						/>						
					</div>
					<div className="form-group">
						<label>
							Confirm Password
						</label>
						<input 				
							type="password" 
							className="form-control"
							name="confirmPassword" 
							placeholder="" 
							value={docebo.get('confirmPassword')} 
							onChange={this.handleChange}	
							onBlur={this.handleBlur}						
						/>						
					</div>																				
					<div>																
						{!docebo.get('processing') &&
							<button 
								type="submit" 
								className="tkc-btn btn-block tkc-btn-red" 																						
							>
								Create Account                
							</button>	  
						}  
						{docebo.get('processing') && 
							<button 
								className="tkc-btn btn-block tkc-btn-outline-red" 
								disabled
							>
								Processing... <Loader />             
							</button>	             
						}  
					</div> 
					<p className="text-danger">						
						{docebo.get('formError')}&nbsp;
					</p>						
				</form>  
			</span>
		);
	}

    render() {
		const { docebo } = this.props.shopStore;   
		if (docebo.get('enrollError')) {
			return (
				<p className="text-danger">
					Sorry! We encountered an error while creating your account. 
					Please email care@kabbalahone.com or call +1-888-898-8358 for assistance.
				</p>
			);
		} 		  
		if (docebo.get('completed')) {
			if (docebo.get('existingUserId')) {
				return (
					<p>
						<span className="text-success">Success!</span> We’ve found an account
						associated with that email address already.
						Login <a href="https://learn.KabbalahOne.com"><strong>here</strong></a> or 
						check your email for alternative instructions.
					</p>
				);				
			}
			setTimeout(function () {
				window.location.href = 'https://learn.KabbalahOne.com';
			}, 4000);
			return (
				<p className="text-success">
					Your account has been created. You will now be redirected 
					to <a href="https://learn.KabbalahOne.com">https://learn.KabbalahOne.com</a> where 
					you can login and access your course(s).
				</p>
			);
		} 
		if (docebo.get('userSearchCompleted')) {
			if (!docebo.get('existingUserId')) {
				return (
					<span>
						{this.renderForm()}
					</span>         
				);  
			} 		
		}
		return (
			<p>
				Please wait while we verify your account... <Loader />
			</p>
		);
	}

}

export default inject('shopStore')(observer(DoceboEnrollment));



// WEBPACK FOOTER //
// ./src/components/DoceboEnrollment.js